module.exports = "<article>\n  <img [src]=\"image\">\n</article>"